export const formServicesArray = (form) => {
    return Object.keys(form.services || {}).filter(s => form.services[s]);
}

export const declOfNum = (number, titles) => {
    let cases = [2, 0, 1, 1, 1, 2];
    return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
}

export const returnOfAccompanyingDocumentsName = 'returnDocuments' //code 'Возврат сопроводительных документов'
export const returnParcelName = 'returnParcel' //code 'Доставка с возвратом'

export const customMatchingServices = (nameOfCurrentService, name, carrierCode) => {
    if (carrierCode !== 'CSE' && nameOfCurrentService === returnOfAccompanyingDocumentsName) {
        return name === returnParcelName;
    }

    return false;
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/utils.js